import React from 'react';
import { LeadForm } from '../../components/LeadForm';
const FITNESS_PROGRAM_OPTIONS = ['Adult Classes', 'Family Classes', 'Kids Taekwondo', 'Fitness / Conditioning', 'General Question'] as const;
export function FitnessHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-1422">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-1423">
        Find Your Fitness Class
      </div>
      <div className="mt-4" data-id="element-1424">
        <LeadForm buttonText="Check Availability" programOptions={FITNESS_PROGRAM_OPTIONS} defaultProgram="Fitness / Conditioning" data-id="element-1425" />
      </div>
    </div>;
}